export var ErrorSeverity;
(function (ErrorSeverity) {
    ErrorSeverity[ErrorSeverity["INFO"] = 200] = "INFO";
    ErrorSeverity[ErrorSeverity["WARNING"] = 400] = "WARNING";
    ErrorSeverity[ErrorSeverity["ERROR"] = 500] = "ERROR";
})(ErrorSeverity || (ErrorSeverity = {}));
export default class ErrorBase extends Error {
    constructor(message, loggingDetails = {}, severity = ErrorSeverity.ERROR) {
        super(message);
        this.loggingDetails = {};
        this.severity = ErrorSeverity.ERROR;
        this.name = 'InitializationError';
        this.loggingDetails = loggingDetails;
        this.severity = severity;
    }
}
